





















































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import EditFreight from './mainlandpackage-edit.vue'
    import CreateFreight from './mainlandpackage-add.vue'
    import Enums from '@/lib/enums'
    import DateUtils from '@/common/js/DateUtils'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);

    class PageFreightRequest extends PageRequest {
        beginTime?: Date;
        endTime?: Date;
        mainLandInterNationalShipment: string;
        cargoCategory: number;
        isSend?: boolean;
        constructor() {
            super();
            this.isSend = null;
        }
    }

    @Component
        ({
            name: "mainlandpackageList",
            components: { CreateFreight,EditFreight }
        })
    export default class Freogjt extends AbpBase {
        whetherStatus = Enums.getEnum(Enums.IsSend, true);
        cargoCategoryType = Enums.getEnum(Enums.CargoCategoryType, true);
        pagerequest: PageFreightRequest = new PageFreightRequest();

        creationTime: Date[] = [];
        editModalShow: boolean = false;
        createModalShow: boolean = false;

        get list() {
            return this.$store.state.mainlandpackage.list;
        };
        get loading() {
            return this.$store.state.mainlandpackage.loading;
        }
   
        create() {
            this.createModalShow = true;
        }
        pageChange(page: number) {
            this.$store.commit('mainlandpackage/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('mainlandpackage/setPageSize', pagesize);
            this.getpage();
        }
        async update(data: any) {
         
            this.$store.state.mainlandpackage.MainLandPackageList = data;
            this.editModalShow = true;
            
            var _this: any = this;
            _this.$previewRefresh();
        }

        async getpage() {

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            //filters
            if (this.creationTime.length > 0) {
                this.pagerequest.beginTime = this.creationTime[0];
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.endTime = this.creationTime[1];
            }

            await this.$store.dispatch({
                type: 'mainlandpackage/getAll',
                data: this.pagerequest
            })
        }
        get pageSize() {
            return this.$store.state.mainlandpackage.pageSize;
        }
        get totalCount() {
            return this.$store.state.mainlandpackage.totalCount;
        }
        get currentPage() {
            return this.$store.state.mainlandpackage.currentPage;
        }
        columns = [
            {
                type: 'selection',
                width: 50,
                align: 'center',
                fixed: 'left',
            }, {
                title: '仓库',
                key: 'warehouseName',
                width: 120,
                fixed: 'left',
            },
            {
                title: '包裹名称',
                key: 'packageName',
                width: 250,
            }, {
                title: '货物类别',
                width: 120,
                key: 'cargoCategory',
                render: (h: any, params: any) => {
                    return h('span', Enums.CargoCategoryType.filter(function (item) { return item.value == params.row.cargoCategory })[0].name);
                }
            },
            //{
            //    title: '包裹基本信息',
            //    key: '',
            //    width: 250,
            //    render: (h: any, params: any) => {
            //        return h('span', "长：" + (params.row.long == 0 ? "" : params.row.long) + "cm," + "宽：" + (params.row.wide == 0 ? "" : params.row.wide) + "cm," + "高：" + (params.row.high == 0 ? "" : params.row.high)+"cm")
            //    }
            //},
            //{
            //    title: '重量【g】',
            //    key: 'weight',
            //    width: 120,
            //}, 
                {
                title: '麻袋编号',
                key: 'mainLandInterNationalShipment',
                width: 180,
            }
            //{
            //    title: '是否已发送',
            //    width: 100,
            //    key: 'isSend',
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.isSend ? this.L('是') : this.L('否'))
            //    }
            //}
            , {
                title: '创建时间',
                key: 'createTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.createTime ? DateUtils.formatLongDate(new Date(params.row.createTime)) : '');
                }
            }, {
                title: '更新时间',
                key: 'updateTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.updateTime ? DateUtils.formatLongDate(new Date(params.row.updateTime)) : '');
                }
            }, {
                title: '创建人',
                key: 'createUserName',
                width: 150,
            }, {
                title: '更新人',
                key: 'updateUserName',
                width: 150,
            }, {
                title: '操作',
                width: 130,
                fixed: 'right',
                key: 'id',
                render: (h: any, params: any) => {
                    var data = params.row;
                    var _this = this;
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '90px',
                                height: '30px',
                                //display: data.isEffective == true ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {

                                    this.update(data);
                                }
                            }

                        }, "修改")
                    ]);
                }
            }]
        async created() {
            this.getpage();
        }
    }
